var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 254,
    viewBox: "0 0 395 254",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.29 61.2764C380.239 61.2764 387.493 68.5423 387.493 77.5052C387.493 86.4681 380.239 93.734 371.29 93.734H278.697C287.646 93.734 294.901 101 294.901 109.963C294.901 118.926 287.646 126.192 278.697 126.192H329.623C338.572 126.192 345.827 133.457 345.827 142.42C345.827 151.383 338.572 158.649 329.623 158.649H306.072C294.789 158.649 285.641 165.915 285.641 174.878C285.641 180.853 290.271 186.263 299.53 191.107C308.479 191.107 315.734 198.373 315.734 207.336C315.734 216.299 308.479 223.564 299.53 223.564H107.401C98.4518 223.564 91.1972 216.299 91.1972 207.336C91.1972 198.373 98.4518 191.107 107.401 191.107H17.1231C8.17407 191.107 0.919434 183.841 0.919434 174.878C0.919434 165.915 8.17407 158.649 17.1231 158.649H109.716C118.665 158.649 125.919 151.383 125.919 142.42C125.919 133.457 118.665 126.192 109.716 126.192H51.8453C42.8963 126.192 35.6416 118.926 35.6416 109.963C35.6416 101 42.8963 93.734 51.8453 93.734H144.438C135.489 93.734 128.234 86.4681 128.234 77.5052C128.234 68.5423 135.489 61.2764 144.438 61.2764H371.29ZM371.29 126.192C380.239 126.192 387.493 133.457 387.493 142.42C387.493 151.383 380.239 158.649 371.29 158.649C362.341 158.649 355.086 151.383 355.086 142.42C355.086 133.457 362.341 126.192 371.29 126.192Z",
    fill: "#F3F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.927 69.3923C136.927 60.8891 136.927 56.6375 138.582 53.3896C140.037 50.5328 142.36 48.2101 145.217 46.7545C148.465 45.0996 152.716 45.0996 161.219 45.0996H222.01C225.254 45.0996 226.875 45.0996 228.423 45.4255C229.796 45.7147 231.122 46.1927 232.364 46.8459C233.763 47.5823 235.012 48.617 237.509 50.6864L254.155 64.4782C257.387 67.156 259.003 68.4949 260.164 70.1391C261.194 71.5958 261.959 73.2226 262.424 74.9447C262.948 76.8884 262.948 78.9869 262.948 83.1841V163.631C262.948 172.134 262.948 176.386 261.293 179.634C259.838 182.491 257.515 184.813 254.658 186.269C251.41 187.924 247.159 187.924 238.656 187.924H161.219C152.716 187.924 148.465 187.924 145.217 186.269C142.36 184.813 140.037 182.491 138.582 179.634C136.927 176.386 136.927 172.134 136.927 163.631V69.3923Z",
    stroke: "#93AFE5",
    strokeWidth: 3.16311,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7.59 6.33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259.14 199.658L250.119 208.68L277.464 236.025C279.955 238.517 283.994 238.517 286.485 236.025V236.025C288.976 233.534 288.976 229.495 286.485 227.004L259.14 199.658Z",
    fill: "#6294F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M262.266 208.197L285.132 231.065",
    stroke: "#CADCFF",
    strokeWidth: 1.17889,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M249.555 187.253L237.715 199.093L250.683 212.062C252.15 213.529 254.528 213.529 255.994 212.062L262.523 205.533C263.99 204.066 263.99 201.688 262.523 200.221L249.555 187.253Z",
    fill: "url(#paint0_linear_6122_2993)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.4496,
    cy: 45.4496,
    r: 45.4496,
    transform: "matrix(-0.707089 0.707124 0.707089 0.707124 219.533 102.905)",
    fill: "#2565DE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0839,
    cy: 35.0839,
    r: 35.0839,
    transform: "matrix(4.21458e-08 1.00003 0.999975 -4.21479e-08 184.616 132.201)",
    fill: "url(#paint1_linear_6122_2993)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M219.185 174.318C218.472 174.318 217.908 174.092 217.495 173.642C217.12 173.153 216.932 172.515 216.932 171.726C216.932 170.562 217.063 169.473 217.326 168.459C217.627 167.407 218.096 166.355 218.735 165.304C219.373 164.252 220.218 163.144 221.27 161.98C222.059 161.078 222.678 160.29 223.129 159.613C223.617 158.9 223.955 158.224 224.143 157.585C224.368 156.947 224.481 156.29 224.481 155.614C224.481 154.374 224.03 153.398 223.129 152.684C222.228 151.97 220.951 151.614 219.298 151.614C217.796 151.614 216.425 151.82 215.185 152.233C213.984 152.609 212.763 153.153 211.523 153.867C210.697 154.355 209.946 154.581 209.27 154.543C208.631 154.468 208.106 154.224 207.692 153.811C207.279 153.398 207.016 152.891 206.904 152.29C206.791 151.689 206.885 151.069 207.185 150.43C207.486 149.792 208.031 149.21 208.819 148.684C210.359 147.67 212.124 146.9 214.115 146.374C216.106 145.811 217.984 145.529 219.749 145.529C222.115 145.529 224.181 145.923 225.946 146.712C227.749 147.501 229.138 148.59 230.115 149.98C231.129 151.369 231.636 153.003 231.636 154.881C231.636 156.045 231.467 157.153 231.129 158.205C230.791 159.219 230.246 160.252 229.495 161.304C228.744 162.318 227.711 163.426 226.397 164.628C225.232 165.679 224.293 166.637 223.58 167.501C222.904 168.365 222.397 169.191 222.059 169.98C221.758 170.768 221.552 171.613 221.439 172.515C221.401 173.041 221.176 173.473 220.763 173.811C220.387 174.149 219.861 174.318 219.185 174.318ZM219.073 186.092C217.796 186.092 216.763 185.698 215.974 184.909C215.223 184.12 214.847 183.106 214.847 181.867C214.847 180.665 215.223 179.689 215.974 178.937C216.763 178.149 217.796 177.754 219.073 177.754C220.387 177.754 221.401 178.149 222.115 178.937C222.866 179.689 223.242 180.665 223.242 181.867C223.242 183.106 222.866 184.12 222.115 184.909C221.401 185.698 220.387 186.092 219.073 186.092Z",
    fill: "#1F64E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.381 14.6963L121.931 36.2463",
    stroke: "#6B98EC",
    strokeWidth: 1.65769,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7769 42.877L119.247 43.5115",
    stroke: "#6B98EC",
    strokeWidth: 1.65769,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M123.588 1.43457L128.583 31.4988",
    stroke: "#6B98EC",
    strokeWidth: 1.65769,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6122_2993",
    x1: 243.635,
    y1: 193.173,
    x2: 259.259,
    y2: 208.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F64E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6122_2993",
    x1: 35.0839,
    y1: 0,
    x2: 35.0839,
    y2: 70.1678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartEmptyIcon);
export default __webpack_public_path__ + "static/media/cart-empty-icon.f823add29f841dcfe3b845967d1e9034.svg";
export { ForwardRef as ReactComponent };